import React, { FC, ReactNode } from 'react';
import { useClientRequestForm } from '~/src/context/client-request-form/use-client-request-form.hook';
import type { CheckboxProps } from '~/src/components/form-components/checkbox/checkbox.types';
import * as Styled from './self-employed-checkbox.styles';

interface SelfEmployedCheckboxProps extends CheckboxProps {
    error?: ReactNode;
}

export const SelfEmployedCheckbox: FC<SelfEmployedCheckboxProps> = ({ error, LabelComponent, ...restProps }) => {
    const { state, dispatch } = useClientRequestForm();

    return (
        <Styled.SelfEmployedCheckbox
            LabelComponent={LabelComponent}
            onChange={(isChecked) =>
                dispatch({
                    type: 'SWITCH_VARIANT',
                    payload: isChecked ? 'selfEmployed' : 'default',
                })
            }
            checked={state.currentVariant === 'selfEmployed'}
            {...restProps}
        />
    );
};
